module.exports = Promise.resolve(parcelRequire("41c0t"))